import useSelectedDataLake from 'data-lake/hooks/useSelectedDataLake';
import useWidgetConfiguration from 'data-lake/preview/hooks/useWidgetConfiguration';

const useUpdateTableFilter = (setFieldValue: (field: string, value: unknown) => void) => {
  const { resetWidget } = useWidgetConfiguration();
  const { setDataLakeFieldsFetchQuery } = useSelectedDataLake();

  return (tableId: string) => {
    resetWidget();
    setFieldValue('fields.fieldFilters', []);
    setFieldValue('table', tableId);
    setDataLakeFieldsFetchQuery((cur) => ({ ...cur, tableId }));
  };
};

export default useUpdateTableFilter;
